export const whatsApp = {
    'UsageReport': ' 919246649070-1614741377@g.us',
    'attendanceReport' : '917382052052-1547014792@g.us',
    'VERSION': 'v15.0',
    'PHONE_NUMBER_ID': '102194172756615',
    'ACCESS_TOKEN': 'EAAMPZAswUgD4BAOUwlRXgVhMgpFW4eXT3z2ZBcVlIPnTtixguAqc74xFS1ydBrTuCD55njvOS7B9ZB4ZAZB3pvFQ4ySYEMZChD1OkKv5RUQ6wZBwOZCfiOB1F3KZCbqL8CHcDReQSOcjGHAZAzX7oy7ylsmaNpTgacI1aUQ8LydnFXR4PMHMZBDH8ZAz',
    'contacts': ['919030069351'],
   'server':'DEV DATA'
}
export default whatsApp;